import React from 'react'
import { Col } from "react-bootstrap";

export function renderSelectField(field)
{
   const { prompt } = field
   
    return(
        <div className='form-group'>
            <label className={field.labelattrs}>{field.label}</label>
            <Col className={field.inputattrs}>
                <select {...field.input}  className="form-control" disabled={field.disabled}>
                    <option key='-1' value='-1'>{ prompt != undefined ? prompt: '...'}</option>
                    {field.values.map(function(value) {
                       return(<option  key={value.abbreviation} value={value.abbreviation}>{value.name}</option>)
                    })}
                </select>
            </Col>
        </div> 
    )   
}


// WEBPACK FOOTER //
// ./src/modules/components/selectfieldcomponent.js